export default "__VITE_ASSET__ClAmXGUA__"